import AppWrapper from 'components/AppWrapper';
import ThemedSegment from 'components/semantic/Segment';
import { Formik } from 'formik';
import React from 'react';

import { useTranslation } from 'react-i18next';
import { CustomTariffRulesFormFields } from 'screens/GroupsAndPolicies/ChargingPolicy/CustomTariffRulesFormFields';
import { TariffFormFields } from 'screens/GroupsAndPolicies/Tariff/TariffFormFields';
import { ChargingPolicy } from 'screens/GroupsAndPolicies/types';
import { Button, Container, Form, Header, Message, Segment } from 'semantic';
import { chargingPolicySchema } from 'screens/GroupsAndPolicies/validation';
import { TariffPreview } from 'screens/GroupsAndPolicies/Tariff/TariffPreview';
import { FormController } from 'screens/GroupsAndPolicies/FormController';

export const PricingForm = () => {
  const { t } = useTranslation();

  const submit = async (values: ChargingPolicy) => {
    console.log('submit', values);
  };

  return (
    <AppWrapper>
      <Container>
        <Formik
          initialValues={{ defaultTariff: {} } as ChargingPolicy}
          validationSchema={chargingPolicySchema}
          onSubmit={submit}>
          {({ values, status, handleSubmit, errors, setFieldValue }) => (
            <Form>
              {errors && <Message error content={JSON.stringify(errors)} />}
              <Header
                as="h1"
                content={t('chargingPolicy.pricing.title', 'Pricing')}
              />
              {/* TODO: Charge for free */}
              <Header
                as="h3"
                content={t(
                  'chargingPolicy.pricing.defaultTariffTitle',
                  'Default Tariff'
                )}
              />
              <p>
                {t(
                  'chargingPolicy.pricing.defaultTariffDescription',
                  'Applied to all customers if no custom tariff applicable'
                )}
              </p>
              <Segment>
                <FormController
                  openInEditMode={true}
                  values={values?.defaultTariff}
                  onSubmit={(values) => setFieldValue('defaultTariff', values)}
                  formComponent={TariffFormFields}
                  previewComponent={TariffPreview}></FormController>
              </Segment>

              <Header
                as="h3"
                content={t(
                  'chargingPolicy.pricing.customTariffRulesTitle',
                  'Custom Tariff Rules'
                )}
              />
              <p>
                {t(
                  'chargingPolicy.pricing.customTariffRulesDescription',
                  'Create an alternative price for specific payment options or customer groups.'
                )}
              </p>
              <ThemedSegment offbackground>
                <CustomTariffRulesFormFields
                  values={values?.customTariffRules}
                />
              </ThemedSegment>

              {status && <Message error content={status} />}

              <Button
                content={t(
                  'chargingPolicy.pricing.save',
                  'Update and Back to Policy'
                )}
                as="button"
                style={{ marginLeft: '0' }} // TODO: look for better solution
                onClick={handleSubmit}
              />
            </Form>
          )}
        </Formik>
      </Container>
    </AppWrapper>
  );
};
